'use client'

import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

export default function CookieBanner(props) {

  const searchParams = useSearchParams();
  const [showCookieBanner, setShowCookieBanner] = useState("0");

  useEffect(() => {
    if (searchParams.get("print")) {
      setShowCookieBanner("0");
    } else {
      setShowCookieBanner("1");
    }
  }, [searchParams]);

  if (showCookieBanner != "1") {
    console.log("CookieBanner: print mode, skipping cookie banner");
    return null;
  }

  return (
    <>
    <script src="https://app.termshub.io/43f757c0-ed52-47e4-8f57-4c83dd627aff/termshub-cookie-consent.js" site="CarCoverage_LLC" async></script>
    </>
  );
}